module.exports = __webpack_public_path__ + "static/media/STAF_bokmål med sørsamisk_sentrert logo_pos(svart).55c8cc7e.svg";